import { render, staticRenderFns } from "./MainLedgerPrintBalance.vue?vue&type=template&id=32168144&scoped=true"
import script from "./MainLedgerPrintBalance.vue?vue&type=script&lang=js"
export * from "./MainLedgerPrintBalance.vue?vue&type=script&lang=js"
import style0 from "./MainLedgerPrintBalance.vue?vue&type=style&index=0&id=32168144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32168144",
  null
  
)

export default component.exports